module.exports = __webpack_public_path__ + "static/media/temp_42.fa4b68b0.jpg";